import { Box, Flex, Text } from "@simplybusiness/mobius";

export interface InstallmentCount {
  labels: string[];
  value: string | undefined;
}
interface PriceModel {
  downpaymentAmount?: string;
  annualPaymentAmount?: string;
  installmentCounts: InstallmentCount[];
}
interface PriceSummaryProps {
  priceModel: PriceModel;
}
export function PriceSummary({ priceModel }: PriceSummaryProps) {
  const { downpaymentAmount, annualPaymentAmount, installmentCounts } =
    priceModel;
  return (
    <Box className="mobius-payment-summary__price-summary-box">
      {downpaymentAmount && (
        <div className="mobius-payment-summary__styled-grid mobius-payment-summary__price-summary-group mobius-payment-summary__border-bottom">
          <Text elementType="span">
            <strong>To pay today</strong>
          </Text>
          <Text elementType="span" className="align-right">
            <strong>{downpaymentAmount}</strong>
          </Text>
        </div>
      )}
      {installmentCounts &&
        installmentCounts.map((installmentCount, index) => (
          <div
            className="mobius-payment-summary__styled-grid mobius-payment-summary__price-summary-group mobius-payment-summary__border-bottom"
            key={index}
          >
            <Text elementType="span">{installmentCount.labels[0]}</Text>
            <Text elementType="span" className="align-right">
              {installmentCount.value}
            </Text>
          </div>
        ))}
      <Flex>
        <div className="mobius-payment-summary__styled-grid mobius-payment-summary__price-summary-group">
          <Text elementType="span">
            Total
            {"\u00A0"}
            <Text elementType="span">(inc.tax + fees)</Text>
          </Text>
          <Text
            elementType="span"
            className="align-right mobius-payment-summary__price-summary-text"
          >
            {annualPaymentAmount}
          </Text>
        </div>
      </Flex>
    </Box>
  );
}
